/* eslint-disable no-param-reassign */
/* eslint-disable max-lines-per-function */
import React from 'react'
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { dispatch } from '/src/hooks/bus/bus'
import BusEvents from '/src/hooks/bus/bus_events'
import { useStore } from 'react-context-hook'

// Hook para gerenciar seleção de linhas no grid, agora suporta condição baseada em função
const useRowsSelection = (onDataSource, selecting) => {
  const [, setSelectedItems] = useStore('selected_items')
  // Adiciona verificação condicional para seleção baseada em função
  const onSelectChange = (e, dataSource) => {
    // Verifica se a seleção é permitida para este item se selecting for função
    if (typeof selecting === 'function' && !selecting(e.dataItem)) return

    const newDataSource = { ...dataSource }

    const i = newDataSource.data.findIndex((i) => i.id === e.dataItem.id)
    newDataSource.data[i].row_selected = !e.dataItem.row_selected
    onDataSource(newDataSource)

    const selectedItems = newDataSource.data.filter((item) => item.row_selected)

    if (selectedItems) {
      setSelectedItems(selectedItems)
    }
    dispatch({ type: BusEvents.SELECTED_ROWS, payload: selectedItems })
  }

  const onHeaderSelectionChange = (e, dataSource) => {
    // Filtra apenas itens selecionáveis se selecting for função
    const selectableItems = dataSource.data.filter(
      (dataItem) => typeof selecting !== 'function' || selecting(dataItem)
    )
    const selectedCount = selectableItems.filter((dataItem) => dataItem.row_selected).length
    const haveItemsChecked = selectedCount > 0
    const isChecked = !haveItemsChecked
    const newDataSource = { ...dataSource }
    newDataSource.data = dataSource.data.map((item) => {
      // Só altera se for selecionável
      if (typeof selecting === 'function' && !selecting(item)) return item
      item.row_selected = isChecked
      return item
    })
    onDataSource(newDataSource)
    const selectedItems = newDataSource.data.filter((item) => item.row_selected)

    if (selectedItems) {
      setSelectedItems(selectedItems)
    }
    dispatch({ type: BusEvents.SELECTED_ROWS, payload: selectedItems })
    e.value = isChecked
  }

  const getHeaderSelectionColumn = (dataSource) => {
    // Conta apenas itens selecionáveis se selecting for função
    const selectableItems =
      typeof selecting === 'function'
        ? dataSource.data.filter((dataItem) => selecting(dataItem))
        : dataSource.data
    const selectedCount = selectableItems.filter((dataItem) => dataItem.row_selected).length

    const dataSize = selectableItems.length
    const isChecked = dataSize === 0 ? false : selectedCount === dataSize

    // Se não há itens selecionáveis, não renderiza a coluna
    if (dataSize === 0) return null

    // Cell customizado para não mostrar checkbox se não selecionável
    const selectionCell = (props) => {
      const isSelectable = typeof selecting !== 'function' || selecting(props.dataItem)
      if (!isSelectable) {
        return <td /> // Não mostra checkbox se não selecionável
      }
      return (
        <td>
          <input
            type="checkbox"
            className="k-checkbox"
            checked={props.dataItem.row_selected}
            onChange={() => onSelectChange({ dataItem: props.dataItem }, dataSource)}
          />
        </td>
      )
    }

    return (
      <Column
        key="row_selected"
        field="row_selected"
        width="80px"
        sortable={false}
        filterable={false}
        resizable={false}
        cell={selectionCell}
        headerCell={() => (
          <input
            data-testid="grid-input-check"
            type="checkbox"
            className="k-checkbox"
            checked={isChecked}
            // eslint-disable-next-line no-param-reassign
            ref={(el) =>
              el && (el.indeterminate = selectedCount > 0 && selectedCount < selectableItems.length)
            }
            onChange={(e) => onHeaderSelectionChange(e, dataSource)}
          />
        )}
      />
    )
  }

  return {
    onSelectChange,
    getHeaderSelectionColumn
  }
}

export default useRowsSelection
